import { render, staticRenderFns } from "./SnapsheetsTemplatesHeader.vue?vue&type=template&id=6dd81ef4&scoped=true&"
import script from "./SnapsheetsTemplatesHeader.vue?vue&type=script&lang=js&"
export * from "./SnapsheetsTemplatesHeader.vue?vue&type=script&lang=js&"
import style0 from "./SnapsheetsTemplatesHeader.vue?vue&type=style&index=0&id=6dd81ef4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd81ef4",
  null
  
)

export default component.exports